import * as serviceWorkerRegistration from 'serviceWorkerRegistration';
import styled from '@emotion/styled/macro';
import locales from 'locales';
import MuiButton from 'components/common/MuiButton';
import Lottie from 'components/common/Lottie';
import { TextView } from 'components/common/CommonStyled';

const Wrapper = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.secondaryColor};
  color: ${({ theme }) => theme.colors.primaryColor};
`;

export default function Content({
  image,
  title,
  subTitle = '',
  isNotFound = false,
  ...rest
}) {
  const handleGoBack = async () => {
    if (isNotFound) {
      const { referrer } = document;
      const { host } = window.location;

      if (referrer) {
        const { host: referrerHost } = new URL(referrer);
        if (window.history.length > 2 && referrerHost === host) {
          window.history.back();
        } else {
          window.location.href = '/';
        }
      } else {
        window.location.href = '/';
      }
    }

    // Get all caches and delete them
    const allCaches = await caches.keys();
    const cacheDeletionPromises = allCaches.map(cache => caches.delete(cache));
    await Promise.all([...cacheDeletionPromises]).finally(() => {
      console.info(`Deleting all caches`);
    });

    await serviceWorkerRegistration.manualUpdate({}).finally(() => {
      console.log('SW - manualUpdate');

      const { referrer } = document;
      const { host } = window.location;

      if (referrer) {
        const { host: referrerHost } = new URL(referrer);
        if (window.history.length > 2 && referrerHost === host) {
          window.location.reload();
          window.history.back();
        } else {
          window.location.reload();
          window.location.href = '/';
        }
      } else {
        window.location.reload();
        window.location.href = '/';
      }
    });
  };

  return (
    <Wrapper>
      <Lottie
        name="image"
        data={{ animationData: image }}
        height={150}
        width={250}
        {...rest}
      />
      <TextView>{title}</TextView>
      {subTitle && <TextView>{subTitle}</TextView>}
      <br />
      <MuiButton
        label={isNotFound ? locales.comeback : locales.reload}
        onClick={handleGoBack}
      />
    </Wrapper>
  );
}
